import React from "react";

//hooks
import useEditField from "../../../hooks/useEditField";

// style
import {cssInput, cssLabel} from "./styled";

const InputEdit = ({name, label = '', initValue = '',  attr = { type: 'text' }}) => {
    const [value, setValue, updateField] = useEditField(initValue);

    const handlerValue = ({ target: { value } }) => setValue(value)

    const handlerUpdate = () => updateField(value, name);
    return (
        <label htmlFor={name }>
            <span style={cssLabel}>{label}</span>
            <input
                id={name}
                name={name}
                value={value}
                style={cssInput}
                {...attr}
                onChange={handlerValue}
                onBlur={handlerUpdate}
            />
        </label>
    )
}

export default InputEdit;


// WEBPACK FOOTER //
// ./src/new-components/admin/fields/input-edit.js